<template>
  <nav class="steps-bar">
    <button
      v-for="(step, i) in steps"
      @click="selectStep(step.key)"
      v-if="step.available"
      :class="{
        'selected': step.key === selected_step,
        'active': step.active,
        'previous': i < selectedStepIndex,
      }"
    >
      <div class="animated">
        <div class="background"></div>
      </div>
      <span>{{ $ml.get(getField(step.key)) }}</span>
      <!-- <span>{{ step.key }}</span> -->
    </button>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  methods: {
    getField (step) {
      var arr = step.split('-');
      if (arr.length == 1) {
        let term = arr[0].split('')[0].toUpperCase() + arr[0].slice(1, arr[0].length);
        return term;
      } else {
        let term1, term2;
        term1 = arr[0].split('')[0].toUpperCase() + arr[0].slice(1, arr[0].length);
        term2 = arr[1].split('')[0].toUpperCase() + arr[1].slice(1, arr[1].length);
        return term1 + ' ' + term2;
      }
    },
    selectStep(step) {
      this.$store.dispatch('program/steps/goToStep', step);
    }
  },
  computed: {
    ...mapGetters({
      selected_step: 'program/steps/selected',
      current_step: 'program/steps/current',
      program: 'program/data',
      steps: 'program/steps/data'
    }),

    selectedStepIndex() {
      return this.steps.findIndex(n => n.key === this.selected_step)
    }
  },
}
</script>

<style lang="scss" scoped>

.steps-bar {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  // overflow: hidden;

  button {
    flex-grow: 1;
    cursor: default;
    background-color: #E0E0E0;
    color: #8B8D91;
    font-size: 12px;
    border: 0 solid #E0E0E0;
    padding: 8px 16px 8px 16px;
    position: relative;
    text-transform: uppercase;
    font-weight: 500;
    user-select: none;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    // border: 1px solid #fff;
    height: 32px;

    span {
      position: relative;
      z-index: 5;
    }

    .animated {
      position: absolute;
      top:0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      // overflow: hidden;

      .background {
        width: 0%;
        height: 100%;
        background-color: $mainGreen;
        transition: .5s;
        &::after {

          // opacity: 0;
          position: absolute;
          content: '';
          right:100%;
          top: 0;
          transition: 0.5s;
          z-index: 2;
          border-top: 0 solid transparent;
          border-bottom: 15px solid transparent;
          border-left: 0 solid $mainGreen;
        }
      }
    }

    &.active {
      background: transparentize($color: $mainGreen, $amount: 0.7);
      color: $mainGreen;
      cursor: pointer;
    }

    &.selected {
      background: $mainGreen;
      color: #fff;
    }

    // &.is_active {
    //   color: #fff;
    //   pointer-events: none;
    //   .animated {
    //     .background {
    //       width: 100%;
    //       &::after {
    //         right: -15px;
    //         // left: unset;
    //         // opacity: 1;
    //         transition: .5s;
    //         border-left-width: 15px;
    //         border-top-width: 17px;
    //       }
    //     }
    //   }

    //   &::after {
    //     opacity: 1;
    //     transform: translateX(calc(100% - 0px));
    //   }
    // }

    &.previous {
      background: $mainGreen;
      color: #fff;
    }
  }
}

</style>
